(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["legal-guarantee-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('buddha-legal-notice')) {
    customElements.define('buddha-legal-notice', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const trigger = this.querySelector('.buddha-legal-notice__trigger');
        const dialog = this.querySelector('dialog');
        if (!trigger || !dialog || !dialog.showModal) return;
        this.initialized = true;
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          dialog.showModal();
        });
        this.querySelector('.buddha-legal-notice__close').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
        });
        dialog.addEventListener('close', () => trigger.focus());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
